import React, { Fragment } from "react";
import { ResultQuestionsMap } from "../..";
import triScores from '../../../resources/triscores.json';

const QuestionsPerModule = ({data, parseBookType}) => {

    const goToQuestion = (number) => {
        data.history.push(`/resultado/${number}`)
    };

    const getTRIScore = (subject, score, value) => {
        switch (subject) {
            case "CIENCIAS_HUMANAS":
                subject = "CH";
                break;
            case "MATEMATICA":
                subject = "MT";
                break;
            case "LINGUAGENS":
                subject = "LC";
                break;
            case "CIENCIAS_DA_NATUREZA":
                subject = "CN";
                break;
        }

        return triScores[subject][score][value].toFixed(1).toString().replace('.', ',');
    };

    let groupedQuestions = data.result.questoes.reduce((groups, item) => {
        const val = item['caderno']
        groups[val] = groups[val] || []
        groups[val].push(item)
        return groups
    }, {});

    return (
        <Fragment>
            {Object.keys(groupedQuestions).map(bookId => {
                const book = {
                    questions: [...groupedQuestions[bookId]],
                    performance: data.result.aproveitamento.cadernos.filter(caderno => caderno.caderno === bookId)[0],
                    info: parseBookType(bookId)
                };

                return (
                    <div className="small-12 cell" key={bookId}>
                        <div className="exam-config-box data">
                            <div className="exam-config-box__icon-area">
                                <i className={`icon-${book.info.icon}`} />
                            </div>
                            <div className="exam-config-box__content">
                                <div className="grid-x grid-margin-x inner-grid">
                                    <div className="small-12 large-6 cell">
                                        <h4 className="text-center">{book.info.name}</h4>
                                        <div className="tri-score-section">
                                            <div className="tri-score-grid">
                                                <div>
                                                    <p className="tri-score-title">NOTA TRI</p>
                                                    <p className="tri-score-subtitle">Com base no desempenho de alunos reais (dados divulgados pelo INEP nas edições anteriores do Enem – 2013 a 2017), o sistema relaciona seu desempenho a uma faixa de nota (mínima e máxima).</p>
                                                </div>
                                                <div className="tri-score-line">
                                                    <p className="no-margin">&rarr;</p>
                                                    <p className="tri-score-text">Nota Máxima</p>
                                                    <p className="tri-score-value" >{getTRIScore(book.performance.caderno, book.performance.questoesCorretas, 'max')}</p>
                                                </div>
                                                <div className="tri-score-line">
                                                    <p className="no-margin">&rarr;</p>
                                                    <p className="tri-score-text">Nota Média</p>
                                                    <p className="tri-score-value" >{getTRIScore(book.performance.caderno, book.performance.questoesCorretas, 'avg')}</p>
                                                </div>
                                                <div className="tri-score-line">
                                                    <p className="no-margin">&rarr;</p>
                                                    <p className="tri-score-text no-border-bottom">Nota Mínima</p>
                                                    <p className="tri-score-value no-border-bottom" >{getTRIScore(book.performance.caderno, book.performance.questoesCorretas, 'min')}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="small-12 large-6 cell">
                                        <p className="score-percentage">{`Aproveitamento de ${book.performance.aproveitamento}%`}</p>
                                        <div className="grid-x grid-margin-x colors-legend">
                                            <div className="correct-legend small-12 medium-auto cell">
                                                <div className="legend-block" />
                                                <div className="legend-text">
                                                    <strong>{book.performance.questoesCorretas}</strong>{book.performance.questoesCorretas == 1 ? 'correta' : 'corretas'}
                                                </div>
                                            </div>
                                            <div className="error-legend small-12 medium-auto cell">
                                                <div className="legend-block" />
                                                <div className="legend-text">
                                                    <strong>{book.performance.questoesErradas}</strong>{book.performance.questoesCorretas == 1 ? 'errada' : 'erradas'}
                                                </div>
                                            </div>
                                            <div className="noresponse-legend small-12 medium-auto cell">
                                                <div className="legend-block" />
                                                <div className="legend-text">
                                                    <strong>{book.performance.questoesNaoRespondidas}</strong>{book.performance.questoesCorretas == 1 ? 'não respondida' : 'não respondidas'}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mt-4">
                                            <div className="small-12 medium-shrink cell text-center pb-2" style={{ paddingBottom: 0 }}>
                                                Questões
                                            </div>
                                            <div className="auto cell">
                                                <ResultQuestionsMap
                                                    questions={book.questions}
                                                    onQuestionSelected={number => goToQuestion(Number(number) + 1)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}
        </Fragment>
    )

}

export default QuestionsPerModule;